var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2MdUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 151,
    viewBox: "0 0 200 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.6401 0H0V113.304H43.0631L32.9809 151L79.5791 113.304H79.6401V113.261L79.6593 113.323L79.6677 113.232L79.6401 113.254V77.891H38.9397V37.1743H79.6401V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.332 0H200V113.304H120.332V77.891H161.041V37.1743H120.332V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2MdUnion);
export default __webpack_public_path__ + "static/media/c2md_union.7f9ac07e69e7c8dddda7c8ab30c7c5ab.svg";
export { ForwardRef as ReactComponent };